function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import CbDiamond from '../diamond';
import CbRewardItem from '../reward-item';
import { getRankReward as getRankRewardData } from '@changba/funny';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "daily-top3-rank-reward"
  }, [_vm._t("top3-title"), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.list, function (reward, rewardIdx) {
    return _c('div', {
      key: rewardIdx,
      staticClass: "daily-top3-item"
    }, [_c('CbRewardItem', {
      attrs: {
        "reward": reward
      },
      scopedSlots: _vm._u([_vm._l(Object.keys(Object.assign({}, _vm.$scopedSlots, _vm.$slots)), function (slot) {
        return {
          key: slot,
          fn: function (scope) {
            return [_vm._t(slot, null, {
              "item": reward,
              "idx": rewardIdx
            }, scope)];
          }
        };
      })], null, true)
    })], 1);
  }), 0)], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-4eb45977',
  render,
  name: 'CbDailyTop3RankReward',
  props,
  data() {
    return {
      rankName: '',
      list: []
    };
  },
  components: {
    CbDiamond,
    CbRewardItem
  },
  mounted() {
    if (this.actKey && this.rankKey) {
      /* 无传入数据则请求 BFF 获取数据 */
      this.getRankRewardList();
    } else {
      /* 有传入数据则直接使用 */
      this.list = this.rewards;
    }
  },
  methods: {
    /* 拉取 BFF 接口数据 */
    getRankRewardList() {
      var _this = this;
      return _asyncToGenerator(function* () {
        var resp = yield getRankRewardData({
          rankId: _this.rankKey,
          actId: _this.actKey
        });
        var {
          code,
          data
        } = resp;
        if (code === 0) {
          var _data$config, _data$config$, _data$config2, _data$config2$;
          _this.rankName = ((_data$config = data.config) == null ? void 0 : (_data$config$ = _data$config[0]) == null ? void 0 : _data$config$.name) || '';
          var multiRewards = (_data$config2 = data.config) == null ? void 0 : (_data$config2$ = _data$config2[0]) == null ? void 0 : _data$config2$.reward.map(v => {
            return v.details.map(d => {
              var {
                name,
                coins,
                img,
                id,
                num,
                expire
              } = d;
              return {
                name,
                coins,
                img,
                id,
                num,
                expire
              };
            });
          });
          _this.list = _this.formatRewardsData(multiRewards);
        } else {
          _this.$toast(resp.msg || '获取榜单奖励失败，请稍候重试吧~');
        }
      })();
    },
    /* 格式化日榜奖励数据，一般为单个奖励 */
    formatRewardsData(originData) {
      var firstChild = originData[0];
      if (Array.isArray(firstChild)) {
        return originData.map(e => e == null ? void 0 : e[0]);
      }
      return originData;
    }
  }
});